exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UnlinkAccountConfirmationPopup_popupWrapper_12Mv {\n  text-align: left;\n}\n\n.UnlinkAccountConfirmationPopup_popupButton_3w-Z {\n  margin-top: 20px;\n  margin-right: 30px;\n\n  width: 240px;\n}\n\n.UnlinkAccountConfirmationPopup_spinner_3-ad {\n  position: static;\n\n  -webkit-transform: none;\n\n          transform: none;\n}\n", ""]);

// exports
exports.locals = {
	"popupWrapper": "UnlinkAccountConfirmationPopup_popupWrapper_12Mv",
	"popupButton": "UnlinkAccountConfirmationPopup_popupButton_3w-Z",
	"spinner": "UnlinkAccountConfirmationPopup_spinner_3-ad"
};